import { createContext, useContext } from "react"

// Kept apart from the provider so that file only exports a component, which Fast Refresh needs.
export const MenuDataContext = createContext(null)

export function useMenuData() {
  const context = useContext(MenuDataContext)
  if (!context) throw new Error("useMenuData must be used inside a MenuDataProvider")
  return context
}
